import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Es para principiantes?',
  a: 'Sí, absolutamente. El Tomo 3 está dedicado 100% a principiantes para que aprendas la técnica correcta y evites los errores comunes desde el día uno.'
}, {
  q: '¿Cómo lo recibo?',
  a: 'Al realizar el pago, recibirás acceso inmediato a tu correo electrónico para descargar todos los tomos y bonos en formato PDF, listos para leer en tu celular, tablet o computadora.'
}, {
  q: '¿Sirve para boulder y deportiva?',
  a: 'Sí, los principios de entrenamiento, técnica y prevención de lesiones aplican para ambas disciplinas. Además, hay capítulos específicos que diferencian el enfoque para boulder y deportiva.'
}, {
  q: '¿Hay garantía?',
  a: 'Sí, tenés 7 días de garantía de satisfacción. Si sentís que el material no te aporta valor, te devolvemos el 100% de tu dinero sin hacer preguntas.'
}, {
  q: '¿En qué formato está?',
  a: 'Todo el material (los 6 tomos y los 3 bonos) se entrega en formato PDF digital de alta calidad, optimizado para lectura en cualquier dispositivo.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-16 px-4 max-w-3xl mx-auto" data-id="element-44">
      <h2 className="text-3xl md:text-4xl font-bebas text-center mb-10" data-id="element-45">
        PREGUNTAS <span className="text-orange-500" data-id="element-46">FRECUENTES</span>
      </h2>

      <div className="space-y-3" data-id="element-47">
        {faqs.map((faq, idx) => {
        const isOpen = openIndex === idx;
        return <div key={idx} className="bg-card border border-gray-800 rounded-lg overflow-hidden" data-id="element-48">
              <button onClick={() => setOpenIndex(isOpen ? null : idx)} className="w-full text-left px-6 py-4 flex justify-between items-center focus:outline-none" data-id="element-49">
                <span className="font-bold text-white pr-4" data-id="element-50">{faq.q}</span>
                <motion.div animate={{
              rotate: isOpen ? 180 : 0
            }} data-id="element-51">
                  <ChevronDown className={`w-5 h-5 ${isOpen ? 'text-orange-500' : 'text-gray-500'}`} data-id="element-52" />
                </motion.div>
              </button>
              <AnimatePresence data-id="element-53">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2
            }} data-id="element-54">
                    <div className="px-6 pb-4 text-gray-400 text-sm" data-id="element-55">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>
    </section>;
}